document.addEventListener("DOMContentLoaded", function () {
  const soundUrl = "https://cdn.shopify.com/s/files/1/0959/3811/7999/files/KoxnwwEQHSLNC4Eqn4RcMrWefYs_1.mp3?v=1775050744";
  const sound = new Audio(soundUrl);
  let audioUnlocked = false;
  let isPlaying = false;
  document.addEventListener("click", function () {
    if (!audioUnlocked) {
      sound.play().then(() => {
        sound.pause();
        sound.currentTime = 0;
        audioUnlocked = true;
      });
    }
  }, { once: true });

  function attachSoundHover(btn) {
    if (!btn || btn.dataset.soundHoverBound === "true") return;
    btn.dataset.soundHoverBound = "true";
    btn.addEventListener("mouseenter", function () {
      if (!audioUnlocked) return;
      if (isPlaying) return;
      isPlaying = true;
      sound.currentTime = 0;
      sound.play().catch(() => {});
    });
    btn.addEventListener("mouseleave", function () {
      sound.pause();
      sound.currentTime = 0;
      isPlaying = false;
    });
  }

  document.querySelectorAll(".sound__hover").forEach(attachSoundHover);

  function enhanceVerseSubmitButton() {
    const buttons = document.querySelectorAll(
      ".template--zero-hour-verse .form_submit_div.text-center button"
    );
    buttons.forEach((btn) => {
      if (btn.classList.contains("hover--button--active")) return;
      btn.classList.add("sound__hover", "hover--button--active");
      attachSoundHover(btn);
    });
  }

  enhanceVerseSubmitButton();

  if (document.querySelector(".template--zero-hour-verse")) {
    const verseObserver = new MutationObserver(enhanceVerseSubmitButton);
    verseObserver.observe(document.body, { childList: true, subtree: true });
  }

  (function defaultSubscriptionSelected() {
    const SELECTOR = '.shopify_subscriptions_app_block input[data-radio-type="selling_plan"]';
    let done = false;

    function trySelect() {
      if (done) return true;
      const radio = document.querySelector(SELECTOR);
      if (!radio) return false;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      done = true;
      return true;
    }

    if (trySelect()) return;

    const observer = new MutationObserver(function () {
      if (trySelect()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () { observer.disconnect(); }, 10000);
  })();

  (function overrideSubscriptionPolicyText() {
    const SELECTOR = "p.shopify_subscriptions_app_policy";
    const REPLACEMENT = "Cancel anytime · Change flavors anytime · Never run out";
    function applyReplacement() {
      const nodes = document.querySelectorAll(SELECTOR);
      let touched = false;
      nodes.forEach(function (el) {
        if (el.textContent !== REPLACEMENT) {
          el.textContent = REPLACEMENT;
          touched = true;
        }
      });
      return touched;
    }
    applyReplacement();
    const observer = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.target.matches && m.target.matches(SELECTOR)) continue;
        if (m.target.closest && m.target.closest(SELECTOR)) continue;
        applyReplacement();
        return;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  })();


  (function liveHeaderCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    const BUBBLE_ID = 'cart-icon-bubble';

    function getSectionId() {
      const bubble = document.getElementById(BUBBLE_ID);
      if (!bubble) return null;
      const wrapper = bubble.closest('[id^="shopify-section-"]');
      return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
    }

    let inFlight = false;
    let queued = false;

    function refresh() {
      if (inFlight) { queued = true; return; }
      const sectionId = getSectionId();
      if (!sectionId) return;

      inFlight = true;
      fetch(window.location.pathname + '?section_id=' + sectionId, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          const tmp = new DOMParser().parseFromString(html, 'text/html');
          const fresh = tmp.getElementById(BUBBLE_ID);
          const current = document.getElementById(BUBBLE_ID);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        })
        .catch(function () {})
        .then(function () {
          inFlight = false;
          if (queued) { queued = false; refresh(); }
        });
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    subscribe(PUB_SUB_EVENTS.quantityUpdate, refresh);
  })();

});